import React from "react";
import { useSelector } from 'react-redux';
import { componentKey as authenticationComponentKey } from "../../web/businesslogic/authentication/AuthenticationSlice";
import General from "../utility/General";

export function useUserTypeInfo() {
    const { signedInUser } = useSelector((state) => state[authenticationComponentKey])
    let userType;
    let userTypeNumber = signedInUser.UserType
    
    userType = General.getUserType(signedInUser.PlanName);

    return {
        userType,
        userTypeNumber,
    }
}